// extracted by mini-css-extract-plugin
export default {"container":"play_container__3qvcf","icon":"play_icon__3BE7N","label":"play_label__1Ki9H"};